mdApp.controller('videoHero', ['$scope', '$element', function($scope, $element){
	var zIndex = 1,
		footer = document.getElementById('footer'),
		footerHeight = 0,
		svgCount = $element[0].getElementsByTagName('svg-sprite').length,
		svgsLoaded = 0;


	// $scope.$on('svgloaded', function(){
	// 	svgsLoaded++;
	// 	if (svgsLoaded >= svgCount) {
	// 		var arrow = $element[0].getElementsByClassName('hero-jump')[0];
	// 		arrow.addEventListener('click', function(){
	// 			TweenLite.to(document.body, 1, {scrollTop: window.innerHeight});
	// 		});
	// 	}
	// });

	// window.addEventListener('scroll', shuffleZIndex);
	// window.addEventListener('resize', resize);

	// function shuffleZIndex(){
	// 	if ((document.body.scrollTop > footerHeight && zIndex == 1) || (document.body.scrollTop <= footerHeight && zIndex == -1)) {
	// 		zIndex = zIndex*-1;
	// 		$element[0].style.zIndex = zIndex;
	// 	}
	// }
	// function resize(){
	// 	footerHeight = footer.clientHeight+30;
	// 	shuffleZIndex();
	// };
	// resize();

	window.onYouTubeIframeAPIReady = function(){
		if ($scope.videoId) {
			var element = $element[0].getElementsByClassName('video-bg')[0];
			var holder = $element[0].getElementsByClassName('video-holder')[0];
			setupBackgroundVideo(element, holder, $scope.videoId);
		}
	}

	function setupBackgroundVideo(el, holder, id){
		$scope.videoAR = 16/9;
		$scope.player = new YT.Player(el, {
			width: '100%',
			height: '100%',
			videoId: id,
			events: {
				'onReady': function(){playerReady(holder);}
			},
			playerVars: {
				origin: window.location.origin,
				controls: 0,
				showinfo: 0,
				modestbranding: 1,
				rel: 0,
			}
		});
	}

	function playerReady(holder){
		$scope.player.setVolume(0);
		$scope.player.playVideo();
		$scope.player.addEventListener('onStateChange', function(state){
			if (state.data == 0) {
				//video ended
				$scope.player.playVideo();
			}
		});
		window.addEventListener('resize', function(){videoResize(holder);});
		videoResize(holder);
	}

	function videoResize(holder){
		var currentAR = (window.innerWidth/window.innerHeight);
		if (currentAR >= $scope.videoAR) {
			holder.style.width = window.innerWidth;
			holder.style.height = window.innerWidth/$scope.videoAR;
		}else if (currentAR < $scope.videoAR) {
			holder.style.width = window.innerHeight*$scope.videoAR;
			holder.style.height = window.innerHeight;
		}
		holder.style.marginLeft = (window.innerWidth-holder.clientWidth)/2+"px";
		holder.style.marginTop = (window.innerHeight-holder.clientHeight)/2+"px";
	}

	var tag = document.createElement('script');

	tag.src = "//www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


}]);
